const typeMap = {
  avi: {
    icon: '/assets/video.svg',
  },
  csv: {
    icon: '/assets/excel.svg',
  },
  default: {
    icon: '/assets/other.svg',
  },
  document: {
    icon: '/assets/word.svg',
  },
  doc: {
    icon: '/assets/word.svg',
  },
  docx: {
    icon: '/assets/word.svg',
  },
  email: {
    icon: '/assets/email.svg',
  },
  eml: {
    icon: '/assets/email.svg',
  },
  msg: {
    icon: '/assets/email.svg',
  },
  gif: {
    icon: '/assets/image.svg',
  },
  html: {
    icon: '/assets/other.svg',
  },
  ico: {
    icon: '/assets/image.svg',
  },
  icon: {
    icon: '/assets/image.svg',
  },
  image: {
    icon: '/assets/image.svg',
  },
  jpeg: {
    icon: '/assets/image.svg',
  },
  jpg: {
    icon: '/assets/image.svg',
  },
  json: {
    icon: '/assets/other.svg',
  },
  mov: {
    icon: '/assets/video.svg',
  },
  mp3: {
    icon: '/assets/audio.svg',
  },
  mp4: {
    icon: '/assets/video.svg',
  },
  odp: {
    icon: '/assets/ppt.svg',
  },
  ods: {
    icon: '/assets/other.svg',
  },
  odt: {
    icon: '/assets/other.svg',
  },
  ogg: {
    icon: '/assets/audio.svg',
  },
  pages: {
    icon: '/assets/word.svg',
  },
  pdf: {
    icon: '/assets/pdf.svg',
  },
  png: {
    icon: '/assets/image.svg',
  },
  ppt: {
    icon: '/assets/ppt.svg',
  },
  rfc822: {
    icon: '/assets/email.svg',
  },
  rtf: {
    icon: '/assets/text.svg',
  },
  svg: {
    icon: '/assets/image.svg',
  },
  text: {
    icon: '/assets/text.svg',
  },
  tiff: {
    icon: '/assets/image.svg',
  },
  txt: {
    icon: '/assets/text.svg',
  },
  video: {
    icon: '/assets/video.svg',
  },
  wav: {
    icon: '/assets/audio.svg',
  },
  webm: {
    icon: '/assets/video.svg',
  },
  webp: {
    icon: '/assets/image.svg',
  },
  wmv: {
    icon: '/assets/video.svg',
  },
  word: {
    icon: '/assets/word.svg',
  },
  xlsx: {
    icon: '/assets/excel.svg',
  },
  xml: {
    icon: '/assets/other.svg',
  },
  xls: {
    icon: '/assets/excel.svg',
  },
  zip: {
    icon: '/assets/other.svg',
  },
  dcm: {
    icon: '/assets/dicom.svg',
  },
  dc3: {
    icon: '/assets/dicom.svg',
  },
};

export const getObjectType = (objectType, fallback) => typeMap[objectType?.toLowerCase()] || fallback || typeMap.default;
